export default {
  unavailable: {
    title: 'Itsepalvelukumppaneiden pääsy on rajoitettu',
    description:
      'Tämä osio ei ole käytettävissä itsepalveluna käyttöönotetuille kumppaneille. Ota tarvittaessa yhteyttä asiakasvastaavaasi.',
  },
};
